import React, { useEffect } from "react";
import { useState } from "react";
import { Form, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../contractbooking.config";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import ContractInformationForm from "./components/ContractInformationForm";
import CounterpartyForm from "./components/CounterPartyForm";
import TermsForm from "./components/TermsForm";
import PreviewForm from "./components/PreviewForm";
import "../../../../assets/styles/InterbankPlacement.css";
import StepsComponent from "../../../../components/layouts/enhancement/StepsComponent";
import StepsCard from "../../../../components/layouts/enhancement/StepsCard";
import dayjs from "dayjs";
import SuccessModal from "../../../../components/layouts/enhancement/SuccessModal";
import ChargeDetails from "./components/ChargeDetails";

const EditInterBankContract = (props) => {
  const { userData } = props;
  const { session } = userData;
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const { state } = useLocation();

  const [useForm] = Form.useForm();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [customerParam, setCustomerParam] = useState({});
  const [searchParam, setSearchParam] = useState("");
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [productData, setProductData] = useState([]);
  const [interestTypeOptions, setInterestTypeOptions] = useState([]);
  const [custodianOptions, setCustodianOptions] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [placementTypeOptions, setPlacementTypeOptions] = useState([]);
  const [collateralTypeOptions, setCollateralTypeOptions] = useState([]);
  const [interstRateTypeData, setInterstRateTypeData] = useState([]);
  const [counterPartyData, setCounterPartyData] = useState([]);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [customerData, setCustomerData] = useState([]);
  const [customerInfo, setCustomerInfo] = useState({});
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [counterPartyDetails, setCounterPartyDetails] = useState(null);
  const [counterPartyExists, setCounterPartyExists] = useState(false);
  const [sendDealConfirmation, setSendDealConfirmation] = useState(false);
  const [isCreateButton, setIsCreateButton] = useState(false);
  const [isCreateScreen, setIsCreateScreen] = useState(false);
  const [contractRef, setContractRef] = useState("");
  const [chargeData, setChargeData] = useState(null);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    contractInformation: null,
    terms: null,
    counterParty: null,
  });

  useEffect(() => {
    getInterbankPlaementById(state);
    getTemplate();
    getInterbankProductTemplate();
  }, []);

  const getInterbankPlaementById = (params) => {
    const url = `${apiConfig.InterbankContract}/${params.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        console.log(
          BOM.DateTime(objDetail?.collateralMaturityDate, "only-date")
        );
        // console.log(objDetail);
        useForm.setFieldsValue({
          // Contract Information
          productCode: objDetail?.product?.id,
          productName: objDetail?.product?.productName,
          productType: objDetail?.product?.productType?.text,
          currencyCode: objDetail?.currency?.code,
          custodian: objDetail?.custodian?.id,
          placementType: objDetail?.placementType?.id ?? null,
          collateralTypeId: objDetail?.collateralType?.id ?? null,
          collateralVolume: objDetail?.collateralVolume ?? "",
          collateralNumber: objDetail?.collateralNumber ?? "",
          collateralValue: objDetail?.collateralValue ?? "",
          collateralCurrency: objDetail?.collateralCurrency ?? null,
          collateralMaturityDate: dayjs(
            BOM.FormatArrayDate(objDetail?.collateralMaturityDate)
          ),
          collateralIdentifier: objDetail?.collateralIdentifier,

          // Terms
          defaultTenor: objDetail.tenor,

          allowPlacementFee: objDetail?.allowRollover,

          // // Interest Configuration
          interestType: objDetail?.interestRateType?.value ?? "",
          // interestType: objDetail?.interestType?.value ?? "",
          amountPlaced: objDetail.amount,
          interestRate: objDetail.interestRate,
          startDate: objDetail.submittedOnDate
            ? dayjs(BOM.FormatArrayDate(objDetail?.submittedOnDate))
            : objDetail.submittedOnDate,
          allowWithholdingTax: objDetail.autoRollover,
          sendDealConfirmation: objDetail.dealConfirmation,
        });
        setSendDealConfirmation(
          objDetail?.dealConfirmation ? objDetail?.dealConfirmation : false
        );

        setContractRef(objDetail.contractReferenceId);
        onChangeProduct(objDetail?.product?.id);
        setTemplateProdDetail(objDetail?.product);
        setCustomerData(objDetail?.client);
        getCustomerDetailById(objDetail?.client);
        getAccountOverviewList(objDetail?.client);
        getClientCounterParty(objDetail?.client);
        setCustomerParam(objDetail?.client);
      }
    });
  };

  const onFinishContractForm = (values) => {
    console.log(values);

    setFormData({ ...formData, contractInformation: values });

    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    console.log(values);

    setFormData({ ...formData, terms: values });
    setCurrent(current + 1);
  };

  const onFinishCounterPartyForm = (values) => {
    console.log(values);

    setFormData({
      ...formData,
      counterParty: values,
    });
    setCurrent(current + 1);
  };

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      apiConfig.InterbankContractTemplate,
      (err, res) => {
        console.log(res);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
        } else {
          const objList = res;
          let tempProducts = [];
          let tempInterestRateType = [];
          let tempCounterPartyOptions = [];
          let tempPlacementTypes = [];
          let tempCollateralTypes = [];

          objList?.productOptions
            ?.filter((item) => item?.status?.text === "Active")
            .forEach((element) => {
              tempProducts.push({
                value: element.id,
                label: element.productName || "",
              });
            });

          objList?.interestRateTypeOptions?.forEach((element) => {
            tempInterestRateType.push({
              value: element.value,
              label: element.text || "",
            });
          });

          objList?.counterpartyOptions?.forEach((element) => {
            tempCounterPartyOptions.push({
              value: element.id,
              label: element.centralBankCode || "",
              bankName: element.bankName || "",
              id: element.id || "",
              swiftCode: element.swiftCode || "",
              allowRTGS: element.allowRTGS || "",
              institutionCode: element.institutionCode || "",
              placementDealAccountLcy: element.placementDealAccountLcy || "",
              centralBankCode: element.centralBankCode || "",
              contactEmail: element.contactEmail || "",
              contactPhoneNo: element.contactPhoneNo || "",
              currentLimitUtilizationLcy:
                element.currentLimitUtilizationLcy || "",
              maxLimitAmountLcy: element.maxLimitAmountLcy || "",
              status: element?.status?.value || "",
            });
          });

          objList?.placementTypeOptions?.forEach((element) => {
            tempPlacementTypes.push({
              value: element.value,
              label: element.text,
            });
          });

          objList?.collateralTypeOptions?.forEach((element) => {
            tempCollateralTypes.push({
              value: element.id,
              label: element.name,
            });
          });

          setProductData(tempProducts);
          setInterstRateTypeData(tempInterestRateType);
          setCounterPartyData(tempCounterPartyOptions);
          setPlacementTypeOptions(tempPlacementTypes);
          setCollateralTypeOptions(tempCollateralTypes);
        }
      }
    );
  }

  const getInterbankProductTemplate = () => {
    // START LOAD
    setIsLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.InterBankPlacementTemplate,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          // setInterbankProductTemplate(res);
          const objList = res;
          let tempInterestTypes = [];
          let tempCustodians = [];
          let tempCurrencies = [];

          const filteredInterestTypes = objList.interestTypes.filter(
            (items) =>
              items.text === "Simple Interest" ||
              items.text === "Compound Interest"
          );

          filteredInterestTypes.forEach((elements) => {
            tempInterestTypes.push({
              value: elements.value,
              label: elements.text,
            });
          });

          objList?.custodians?.forEach((element) => {
            tempCustodians.push({
              value: element.id,
              label: element.name,
            });
          });

          objList?.currencies?.forEach((element) => {
            tempCurrencies.push({
              value: element?.code,
              label: `${element?.displaySymbol || element?.code} ${
                element?.displayLabel
              }`,
              symbol: element?.displaySymbol,
            });
          });

          setInterestTypeOptions(tempInterestTypes);
          setCustodianOptions(tempCustodians);
          setCurrencies(tempCurrencies);

          setIsLoading(false);
        }
      }
    );
  };

  const onChangeProduct = (productParam) => {
    const url = `${apiConfig.InterBankPlacementProducts}/${productParam}`;

    let body = {
      session,
    };

    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        setTemplateProdDetail(res);
        const objList = res;
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempPenaltyOptions = [];

        // console.log(objList);

        const currentTenor = useForm.getFieldValue("defaultTenor");
        const currentInterestRate = useForm.getFieldValue("interestRate");

        const tenorToUse =
          currentTenor !== undefined &&
          currentTenor !== null &&
          currentTenor !== 0
            ? currentTenor
            : objList?.defaultTenor || 0;

        const interestRateToUse =
          currentInterestRate !== undefined &&
          currentInterestRate !== null &&
          currentInterestRate !== 0
            ? currentInterestRate
            : objList?.defaultRate || 0;

        // || objList?.nominalAnnualInterestRate

        console.log(
          "Current tenor:",
          currentTenor,
          "New default:",
          objList?.defaultTenor,
          "Using:",
          tenorToUse
        );
        console.log(
          "Current rate:",
          currentInterestRate,
          "New default:",
          objList?.defaultRate,
          "Using:",
          interestRateToUse
        );

        useForm.setFieldsValue({
          // Contract Information
          productCode: objList?.productCode || "",
          productName: objList?.productName || "",
          productType: objList?.productType?.text || "",
          currencyCode: objList?.currencyCode || "",
          // custodian: objList?.custodian?.id || "",

          // Terms
          decimalPlaces: objList?.currency?.decimalPlaces || 0,
          inMultiplesOf: objList?.currency?.inMultiplesOf || 1,
          submittedOnDate: dayjs(),
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate || 0,

          // Terms Configuration
          minTenor: objList?.minTenor || 0,
          maxTenor: objList?.maxTenor || 0,
          defaultTenor: tenorToUse,
          // defaultTenor: objList?.defaultTenor || 0,
          allowRollover: objList?.allowRollover || false,
          autoRollover: objList?.autoRollover || false,
          backdatedValueDateAllowed:
            objList?.backdatedValueDateAllowed || false,
          allowEarlyTermination: objList?.allowEarlyTermination || false,
          earlyTerminationWithPenalty:
            objList?.earlyTerminationWithPenalty || false,
          maturityDateAdjustment: objList?.maturityDateAdjustment?.value || "",
          allowPlacementFee: objList?.allowPlacementFee || false,
          placementFeeWithPenalty: objList?.placementFeeWithPenalty || false,

          // Interest Configuration
          // interestType: objList?.interestRateType?.value || "",
          // interestType: objList?.interestRateType?.value ?? "",

          // interestType: objList?.interestRateType?.text || "",
          interestRate: interestRateToUse,
          // interestRate: objList?.defaultRate || 0,
          interestCalculationBasis:
            objList?.interestCalculationBasis?.text || "",
          interestPostingType: objList?.interestPostingType?.text || "",
          allowWithholdingTax: objList?.allowWithholdingTax || false,
          withholdingTax: objList?.withholdingTax || 0,
          withholdingTaxCharges: objList?.withholdingTax?.name || "",

          // Counterparty Settings
          counterpartyTypes:
            objList?.counterpartyTypes
              ?.map((type) => type?.id)
              .filter(Boolean) || [],
          kycRequirements: objList?.kycRequirements?.[0]?.id || "",
          activateDealConfirmation: objList?.activateDealConfirmation || false,
          allowSwiftCode: objList?.allowSwiftCode || false,
          allowRTGS: objList?.allowRTGS || false,

          // Compliance Settings
          centralBankReports:
            objList?.centralBankReports
              ?.map((report) => report?.id)
              .filter(Boolean) || [],
          riskLimit: objList?.riskLimit?.toString() || "0",
          mandatoryAMLScreening: objList?.mandatoryAMLScreening || false,
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setChargeData({
          allowTax: objList?.allowTax,
          taxGroup: objList?.taxGroup,
        });

        // setProductData(tempProducts);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setIsProductSelected(true);
        setIsLoading(false);
      }
    });
  };

  const getCustomerDetailById = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${param.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCurrentCustomer = {
          key: objDetail?.id,
          id: objDetail?.id,
          name: objDetail?.displayName ? objDetail?.displayName : "-",
          clientno: objDetail?.accountNo ? objDetail?.accountNo : "-",
          externalId: objDetail?.externalId ? objDetail?.externalId : "-",
          status: objDetail?.status ? objDetail?.status.value : "-",
          branch: objDetail?.officeName ? objDetail?.officeName : "-",
          staff: objDetail?.staffName ? objDetail?.staffName : "-",
          branchId: objDetail?.officeId ? objDetail?.officeId : "-",
          customerType: objDetail?.legalForm ? objDetail?.legalForm.value : "-",
        };

        setCustomerInfo(tempCurrentCustomer);

        setShowDetailsForm(true);

        // setCurrentCustomerDetails(tempCurrentCustomer);
        setIsLoading(false);
      }
    });
  };

  const getAccountOverviewList = (param) => {
    const url = `${apiConfig.Clients}/${param.id}/accounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempSavingsArray = [];

        // prepare table for savings, current, term deposit accounts
        objList?.savingsAccounts
          ?.filter((item) => item?.status?.active === true)
          ?.forEach((element) => {
            tempSavingsArray.push({
              value: element?.id,
              label: `${element?.accountNo || "-"} - ${
                element?.productName || "-"
              }`,
              // Keep all original data
              ...element,
              key: element?.id,
              id: element?.id,
              accountNo: element?.accountNo || "-",
              productName: element?.productName || "-",
              status:
                element?.status.active === true
                  ? "Active"
                  : element?.status.active === false
                  ? "Closed"
                  : "-",
            });
          });
        // setSavingsList(tempSavingsArray);
      }
    });
  };

  const getClientCounterParty = (param) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Counterparty}/${param.id}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        // setIsLoading(false);
        setCounterPartyExists(false);
        setCounterPartyDetails(null);
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // setIsLoading(false);
        setCounterPartyExists(true);
        const objList = res;
        setCounterPartyDetails(objList);

        useForm.setFieldsValue({
          // Counterparty Settings
          bankName: objList?.bankName,
          bankCode: objList?.centralBankCode,
          status: objList?.status?.value,
          institutionCode: objList?.institutionCode,
          swiftCode: objList?.swiftCode,
          currentLimitUtilizationLcy: objList?.currentLimitUtilizationLcy,
          maxLimitAmountLcy: objList?.maxLimitAmountLcy,
          allowSwiftCode: objList.allowSwiftCode,
          allowRTGS: objList.allowRTGS,
          email: objList?.contactEmail,
          externalDealAccountNumber: objList.externalDealAccountNumber,
          kycStatus: objList?.kycStatus?.value,
        });
      }
    });
  };

  const handleSubmit = (formValues) => {
    console.log("Submitting form data:", formData);

    formValues = {
      ...formData.contractInformation,
      ...formData.terms,
      ...formData.counterParty,
    };

    const payloadData = {};

    payloadData.productId = templateProdDetail.id;
    payloadData.clientId = customerInfo.id;
    payloadData.counterpartyId = counterPartyDetails.id;
    payloadData.submittedOnDate = BOM.DateTime(
      formValues.startDate,
      "only-date"
    );
    payloadData.custodian = formValues.custodian;
    payloadData.placementType = formValues.placementType;
    payloadData.collateralTypeId = formValues.collateralTypeId;
    payloadData.collateralVolume = formValues.collateralVolume;
    payloadData.collateralNumber = formValues.collateralNumber;
    payloadData.collateralValue = formValues.collateralValue;
    payloadData.collateralCurrency = formValues.collateralCurrency;
    payloadData.collateralMaturityDate = BOM.DateTime(
      formValues.collateralMaturityDate,
      "only-date"
    );
    payloadData.collateralIdentifier = formValues.collateralIdentifier;
    payloadData.interestType = formValues.interestType;
    payloadData.interestRate = formValues.interestRate;
    payloadData.tenor = formValues.defaultTenor;
    payloadData.amount = formValues.amountPlaced;
    payloadData.allowRollover = formValues.allowPlacementFee;
    payloadData.autoRollover = formValues.allowWithholdingTax;
    payloadData.dealConfirmation = formValues.sendDealConfirmation;

    // console.log(payloadData);
    // return;

    const url = `${apiConfig.InterbankContract}/${state.id}`;

    const body = {
      ...payloadData,
      method: "PUT",
      session,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        setIsModalVisible(true);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const handleGoBack = () => {
    navigate("/interbank-contract");
  };

  // Define the content for each step
  const stepsContent = [
    {
      title: "Contract Information",
      component: (
        <ContractInformationForm
          searchParam={searchParam}
          customerInfo={customerInfo}
          currencyData={currencyData}
          showDetailsForm={showDetailsForm}
          custodianOptions={custodianOptions}
          placementTypeOptions={placementTypeOptions}
          collateralTypeOptions={collateralTypeOptions}
          currencies={currencies}
          onFinish={onFinishContractForm}
          form={useForm}
          initialValues={formData.contractInformation}
          onChangeProduct={onChangeProduct}
          productData={productData}
          isProductSelected={isProductSelected}
          userData={userData}
        />
      ),
    },
    {
      title: "Terms",
      component: (
        <TermsForm
          onFinish={onFinishTermsForm}
          form={useForm}
          initialValues={formData.terms}
          currencyData={currencyData}
          templateProdDetail={templateProdDetail}
          interstRateTypeData={interstRateTypeData}
          interestTypeOptions={interestTypeOptions}
        />
      ),
    },
    {
      title: "Charge Details",
      component: <ChargeDetails chargeData={chargeData} />,
    },
    {
      title: "Counterparty Information",
      component: (
        <CounterpartyForm
          onFinish={onFinishCounterPartyForm}
          form={useForm}
          initialValues={formData.terms}
          currencyData={currencyData}
          templateProdDetail={templateProdDetail}
          counterPartyData={counterPartyData}
          setSendDealConfirmation={setSendDealConfirmation}
          sendDealConfirmation={sendDealConfirmation}
        />
      ),
    },
    {
      title: "Preview",
      component: (
        <PreviewForm
          formData={formData}
          templateProdDetail={templateProdDetail}
          custodianOptions={custodianOptions}
          placementTypeOptions={placementTypeOptions}
          collateralTypeOptions={collateralTypeOptions}
          currencies={currencies}
          productData={productData}
          interestTypeOptions={interestTypeOptions}
          onCreateProduct={handleSubmit}
          isCreateButton={isCreateButton}
          onGoBack={handleGoBack}
          contractRef={contractRef}
          chargeData={chargeData}
        />
      ),
    },
  ];

  const next = () => {
    const stepsUsingForm = [0, 1, 3]; // indices of steps

    if (stepsUsingForm.includes(current)) {
      useForm.submit(); // only those steps trigger onFinish
    } else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    const prevStep = current - 1;
    setCurrent(prevStep);

    // Remove the last completed step if going back
    setCompletedSteps((prev) => {
      const updated = prev.filter((stepIndex) => stepIndex < prevStep);
      return updated;
    });
  };

  return (
    <MainLayout pageItems={staticConfig.editcontractbookingInterbankPlacement}>
      <TopContent
        pageTitle={labelConfig.manageContractBookingInterbankplacement}
        createPageTitle={labelConfig.updateContract}
      />
      <Spin spinning={isLoading} size="large">
        <div
          className="contract-form-container"
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            height: "720px",
            widtth: "100%",
          }}
        >
          {/* Left side - Vertical steps */}
          <StepsComponent
            steps={stepsContent}
            current={current}
            completedSteps={completedSteps}
          />

          <StepsCard
            current={current}
            onNext={next}
            onPrev={prev}
            totalSteps={5}
            nextLabel={`Next - ${stepsContent[current + 1]?.title || ""}`}
            onSubmit={handleSubmit}
            submitLabel="Update Contract"
            onGoBack={handleGoBack}
          >
            {stepsContent[current].component}
          </StepsCard>

          <SuccessModal
            visible={isModalVisible}
            onClose={handleGoBack}
            successMessage={
              "Your Interbank Placement Contract has been updated successfully."
            }
            isCreateButton={isCreateButton}
          />
        </div>
      </Spin>
    </MainLayout>
  );
};

export default EditInterBankContract;
